import { useCallback, useState } from "react";
import toast from 'react-hot-toast';

/**
 * Use this hook recipe whenever a toggler is needed
 * @param {boolean} initialState setInitialValue
 * @returns Array
 */
export const useToggle = (initialState = false) => {

  const [state, setState] = useState(initialState);

  // Define and memorize toggler function in case we pass down the comopnent,
  // This function change the boolean value to it's opposite value
  const toggle = useCallback(() => setState(state => !state), []);

  return [state, toggle]
}

export function useCopyToClipboard() {
  const [copiedText, setCopiedText] = useState(null)

  const copy = async text => {
    if (!navigator?.clipboard) {
      console.warn('Clipboard not supported')
      toast.error('Unable to copy. Your browser does not support clipboard API')
      return false
    }

    // Try to save to clipboard then save it in the state if worked
    try {
      await navigator.clipboard.writeText(text)
      setCopiedText(text)
      toast.success('Copied to clipboard')
      return true
    } catch (error) {
      console.warn('', error)
      toast.error('Copy failed')
      setCopiedText(null)
      return false
    }
  }

  return [copiedText, copy]
}
export { default as useDetectClickOutside } from './useDetectClickOutside';